module.exports = __webpack_public_path__ + "img/itinerary_list_desktop.2ed4244f.png";